import React, {Component} from 'react'
import TextsmsIcon from '@material-ui/icons/Textsms';
import FaceIcon from '@material-ui/icons/Face';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import GroupIcon from '@material-ui/icons/Group';

import ArrowBackRoundedIcon from '@material-ui/icons/ArrowBackRounded';
import './ChatRoom.css'
import FlashCountBadge from '../FunctionArea/FlashCountBadge'


class ChatRoomExpandArea extends Component {
    constructor(props) {
        super(props)
        this.state = {
            shrink:true,
            expandContain:null
        }
    }

    componentDidMount(){

    }

    componentDidUpdate(prevProps){
      
    }

    rowContainer=()=>{
        
            if(this.props.expandContain === "unreadMessageList")
            {
                return <div className={"chatRoomRowOverflowContainer"}>{this.createUnreadMessageRow()}</div>      
            }
            else if(this.props.expandContain === "userList")
            {
                return <div className={"chatRoomRowOverflowContainer"}>{this.createUserRow()}</div>
            }
            else if(this.props.expandContain === "unreadQueryList")
            {
            return <div className={"chatRoomRowOverflowContainer"}>{this.createUnreadQueryRow()}</div>
            }
            else if(this.props.expandContain === "visitorList")
            {
            return <div className={"chatRoomRowOverflowContainer"}>{this.createVisitorRow()}</div>
            }
        
    }

    createUnreadMessageRow=()=>{
        if(this.props.unreadMessage)
        {
            if(this.props.unreadMessage.length>0)
            {
                let outputObj = {}

                this.props.unreadMessage.forEach((chat,index)=>{
                    if(outputObj[chat.channelID])
                    {
                        let tempObj = chat
                        tempObj.count = outputObj[chat.channelID].count + 1
                        outputObj[chat.channelID] = tempObj
                    }
                    else
                    {
                        let tempObj = chat
                        tempObj.count = 1
                        outputObj[chat.channelID] = tempObj
                    }
                })

                let output = Object.keys(outputObj).map((chatChannel,index)=>{
                    return (
                        <div className={"chatRoomContainerDoubleRows"} key={index} onClick={(e)=>this.invokeChatChannel(e, {userID:outputObj[chatChannel].emitID, userName:outputObj[chatChannel].emitName})}>
                            <div className={"chatRoomContainerSingleRow"} >
                                {"與 "+outputObj[chatChannel].emitName+" 的對話"}
                                <div className={"unreadMessageNumberBadge"}><FlashCountBadge countNumber={outputObj[chatChannel].count} badgeType={"red-blue"}/></div>
                            </div>
                            <div className={"chatRoomContainerSingleRow"} >
                                {"最近一則訊息 ： "}
                            </div>
                            <div className={"unreadQueryRow"}>
                                <div className={"chatRoomContainerSingleRow"} >
                                    <div className={"chatRoomContainerQueryTitle"}>{outputObj[chatChannel].emitName}</div>
                                    <div className={"chatRoomContainerTime"}>{outputObj[chatChannel].emitTime}</div>
                                </div>
                                <div className={"chatRoomContainerSingleRow"}>
                                    <div className={"chatRoomContainerChat"}>{outputObj[chatChannel].emitMessage ? outputObj[chatChannel].emitMessage:"一張截圖"}</div>
                                </div>
                            </div>
                        </div>
                    )
                })

                return output
            }
            else
            {
                return <div className={"chatRoomContainerRow"}>沒有新訊息</div>
            }
        }
        else
        {
            return null
        }

    }

    createUserRow=()=>{
        return <div className={"chatRoomRowContainer"}>
             <div className={"chatRoomContainerHeader"}>在線使用者</div>
            {this.createCurrentUsers()}
            <div className={"chatRoomContainerHeader"}>離線使用者</div>
            {this.createOfflineUsers()}
        </div>
    }

    createCurrentUsers=()=>{
        if(this.props.currentUsers && Object.keys(this.props.currentUsers).length > 0)
        {
            let output = Object.keys(this.props.currentUsers).map(user=>{
                return <div className={"chatRoomContainerRow"} key={this.props.currentUsers[user].userID} onClick={(e)=>this.invokeChatChannel(e,this.props.currentUsers[user])}>{this.props.currentUsers[user].userName}</div> 
            })

            return output
        }
        else
        {
            return <div className={"chatRoomContainerRow"}>線上無使用者</div> 
        }
    }

    createOfflineUsers=()=>{
        if(this.props.allUsers)
        {
            let output = []
            this.props.allUsers.forEach(user => {
                if(!this.props.currentUsers[user.userID] && user.userID !== this.props.userID)
                {
                    let tempDom = <div className={"chatRoomContainerRow offline"} key={user.userID} onClick={(e)=>this.invokeChatChannel(e,user)}>{user.userName}</div> 

                    output.push(tempDom)
                }
            });

            return output
        }
        else
        {
            return null
        }
    }

    createUnreadQueryRow=()=>{
        if(this.props.unreadQuery)
        {
            if(this.props.unreadQuery.length>0)
            {
                let outputObj = {}

                this.props.unreadQuery.forEach((query,index)=>{
                    if(outputObj[query.channelID])
                    {
                        let tempObj = {
                            channelID : query.channelID,
                            emitDate : query.emitDate,
                            emitID : query.emitID,
                            emitIP : query.emitIP,
                            emitImage : query.emitImage,
                            emitMessage : query.emitMessage,
                            emitName : query.emitName,
                            emitTime : query.emitTime,
                            read : query.read,
                            count : outputObj[query.channelID].count + 1
                        } 
                        outputObj[query.channelID] = tempObj
                    }
                    else
                    {
                        let tempObj = {
                            channelID : query.channelID,
                            emitDate : query.emitDate,
                            emitID : query.emitID,
                            emitIP : query.emitIP,
                            emitImage : query.emitImage,
                            emitMessage : query.emitMessage,
                            emitName : query.emitName,
                            emitTime : query.emitTime,
                            read : query.read,
                            count : 1
                        }
                        outputObj[query.channelID] = tempObj
                    }
                })

                let output = Object.keys(outputObj).map((queryChannel,index)=>{
                    return (
                        <div className={"chatRoomContainerDoubleRows"} key={index} onClick={(e)=>this.invokeQueryChannel(e, {visitorID:outputObj[queryChannel].channelID, visitorName:outputObj[queryChannel].emitName})}>
                            <div className={"chatRoomContainerSingleRow"} >
                                {"來訪者 "+queryChannel}
                                <div className={"unreadMessageNumberBadge"}><FlashCountBadge countNumber={outputObj[queryChannel].count} badgeType={"red-blue"}/></div>
                            </div>
                            <div className={"chatRoomContainerSingleRow"} >
                                {"最近一則訊息 ： "}
                            </div>
                            <div className={"unreadQueryRow"}>
                                <div className={"chatRoomContainerSingleRow"} >
                                    <div className={"chatRoomContainerQueryTitle"}>{outputObj[queryChannel].emitName}</div>
                                    <div className={"chatRoomContainerTime"}>{outputObj[queryChannel].emitTime}</div>
                                </div>
                                <div className={"chatRoomContainerSingleRow"}>
                                    <div className={"chatRoomContainerChat"}>{outputObj[queryChannel].emitMessage ? outputObj[queryChannel].emitMessage:"一張截圖"}</div>
                                </div>
                            </div>
                        </div>
                    )
                })

                return output
            }
            else
            {
                return <div className={"chatRoomContainerRow"}>沒有新訊息</div>
            }
        }
        else
        {
            return null
        }
    }

    createVisitorRow=()=>{
        return  <div className={"chatRoomRowContainer"}>
                    <div className={"chatRoomContainerHeader"}>在線來訪者</div>
                    {this.createCurrentVisitors()}
                </div>
    }

    createCurrentVisitors=()=>{
        if(this.props.currentVisitors && Object.keys(this.props.currentVisitors).length > 0)
        {
            let output = Object.keys(this.props.currentVisitors).map(visitor=>{
                return <div className={"chatRoomContainerRow"} key={this.props.currentVisitors[visitor].visitorID} onClick={(e)=>this.invokeQueryChannel(e,this.props.currentVisitors[visitor])}>{this.props.currentVisitors[visitor].visitorName}</div> 
            })

            return output
        }
        else
        {
            return <div className={"chatRoomContainerRow"}>線上無使用者</div> 
        }
    }

    createShrinkContainer=()=>{
        return <div>
                    <div className={"userCountRow"} onClick={this.expandUnreadArea}><div className={"userCountTitle"}><TextsmsIcon fontSize={"large"}/></div><div className={"messageNumberBadge"}><FlashCountBadge countNumber={this.props.unreadMessage.length} badgeType={"red-blue"}/></div></div>
                    <div className={"userCountRow"} onClick={this.expandUserList}><div className={"userCountTitle"}><FaceIcon fontSize={"large"}/></div><div className={"messageNumberBadge"}><FlashCountBadge countNumber={this.props.currentUsers? Object.keys(this.props.currentUsers).length : "0"} badgeType={"blue"}/></div></div>
                    <div className={"chatRoomDivideLine"}></div>
                    <div className={"userCountRow"} onClick={this.expandUnreadQueryArea}><div className={"userCountTitle"}><LiveHelpIcon fontSize={"large"}/></div><div className={"messageNumberBadge"}><FlashCountBadge countNumber={this.props.unreadQuery.length} badgeType={"red-blue"}/></div></div>
                    <div className={"userCountRow"} onClick={this.expandVisitorList}><div className={"userCountTitle"}><GroupIcon fontSize={"large"}/></div><div className={"messageNumberBadge"}><FlashCountBadge countNumber={this.props.currentVisitors? Object.keys(this.props.currentVisitors).length : "0"} badgeType={"blue"}/></div></div>
                </div>
    }

    shrinkContainer=()=>{
        this.props.getCloseExpandContainClose()
    }

    

    invokeChatChannel=(e,user)=>{
        this.props.getChatChannel(user)
    }

    invokeQueryChannel=(e,visitor)=>{
        this.props.getQueryChannel(visitor)
    }

    containerTitle=()=>{
        if(this.state.expandContain === "unreadMessageList")
        {
            return "新訊息"
        }
        else if(this.state.expandContain === "userList")
        {
            return null
        }
        else
        {
            return null
        }
    }

    render(){
        return(
            <div className={"chatRoomExpandArea"} >
                <div style={{display:"flex"}}><div className={"toggleArea"} onClick={this.shrinkContainer}><ArrowBackRoundedIcon fontSize={"small"}/></div><div className={"chatRoomContainerHeader"}>{this.containerTitle()}</div></div>             
                {this.rowContainer()}              
            </div>    
        )
    }
}

export default ChatRoomExpandArea